









































































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  QueryReportPdfPageList,
  DeleteReportPdf,
  EnableReportPdf,
  ExportReportPdf,
} from "@/api/reportSetting";
import add from "./add.vue";
import edit from "./edit.vue";
import stand from "./stand.vue";
import importData from "./importData.vue";

@Component({
  components: { add, edit, stand, importData },
})
export default class extends AbpBase {
  tableData: any = [];
  totalCount = 0;
  editShow = false;
  editData: any = {};
  addShow = false;
  standShow = false;
  loading = false;
  importShow = false;
  pageRequest: any = {
    page: 1,
    pageSize: 10,
    queryString: "",
  };

  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
      title: "报表名称",
      key: "reportName",
      minWidth: 200,
    },
    {
      title: "状态",
      key: "status",
      width: 100,
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        let status = "未启用";
        let style = { color: "lightgray" };
        if (p.row.isEnabled) {
          status = "已启用";
          style.color = "green";
        }
        return h(
          "span",
          {
            style: style,
          },
          status
        );
      },
    },
    {
      title: "纸张规格",
      key: "standard",
      width: 200,
      render: (h: any, p: any) => {
        return h(
          "span",
          {},
          `${p.row.standardCode}(${p.row.width}x${p.row.height}mm)`
        );
      },
    },
    {
      title: "上边距",
      key: "paddingTop",
      width: 100,
    },
    {
      title: "下边距",
      key: "paddingBottom",
      width: 100,
    },
    {
      title: "左边距",
      key: "paddingLeft",
      width: 100,
    },
    {
      title: "右边距",
      key: "paddingRight",
      width: 100,
    },
    {
      title: "显示页码",
      key: "isShowPage",
      width: 120,
      render: (h: any, p: any) => {
        return h("span", {}, p.row.isShowPage ? "是" : "否");
      },
    },
    {
      title: "默认字体",
      key: "defaultFontSize",
      width: 110,
    },
    {
      title: "操作",
      width: 225,
      fixed: "right",
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "10px",
              },
              on: {
                click: () => {
                  this.edit(p.row);
                },
              },
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                marginRight: "10px",
              },
              on: {
                click: () => {
                  this.del(p.row);
                },
              },
            },
            "删除"
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: () => {
                  this.enable(p.row);
                },
              },
            },
            p.row.isEnabled ? "禁用" : "启用"
          ),
        ]);
      },
    },
  ];

  created() {
    this.query();
  }

  query() {
    this.pageRequest.page = 1;
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await QueryReportPdfPageList(this.pageRequest);
    this.tableData = res.items;
    this.totalCount = res.totalCount;
    this.loading = false;
  }

  pageChange(val) {
    this.pageRequest.page = val;
    this.getData();
  }

  add() {
    this.addShow = true;
  }

  edit(row: any) {
    this.editData = {
      mode: "edit",
      data: row,
    };
    this.editShow = true;
  }

  del(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteReportPdf({ reportId: row.id });
        this.getData();
      },
    });
  }

  async enable(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "是否确定执行此操作？",
      onOk: async () => {
        let payload = {
          reportId: row.id,
          isEnabled: row.isEnabled == true ? false : true,
        };
        await EnableReportPdf(payload);
        this.getData();
      },
    });
  }

  stand() {
    this.standShow = true;
  }

  async exportData() {
    let filterCheck = (this.$refs.tabList as any).getSelection();
    if (filterCheck.length == 0) {
      this.$Message.warning("请勾选要导出的配置报表");
      return false;
    }

    let payload = { idList: filterCheck.map((x) => x.id) };
    this.loading = true;
    let res = await ExportReportPdf(payload);
    this.loading = false;
    if (res.status == 1) {
      window.open(`${XMLHTTP_BASEURL}/${res.objects}`);
    }
  }

  importData() {
    this.importShow = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/reportSetting/index.vue